import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class StreamSource extends ApplicationRecord {
  static jsonapiType = "stream_sources";

  @Attr() action: string;

  @Attr() streamId: number;

  @Attr() targetId: number;

  @Attr({ persist: false }) targetName: string;

  @Attr() targetType: string;
}

export default StreamSource;
